import React, {useState} from 'react';
import getUserLocale from 'get-user-locale';
import {Langs} from "./utils";
import queryString from "query-string";
import {IntlProvider} from "react-intl";

export const LanguageContext = React.createContext();

function LanguageProvider({children}) {
    const [i18nConfig, setLanguage] = useState(getLanguage())

    function getLanguage(lang: string) {
        if (!lang) {
            lang = window.location.search;
        }
        lang = (lang && lang.length > 2) ? queryString.parse(lang).lang : lang;
        lang = Langs[lang] ? lang : getUserLocale().substr(0, 2).toLowerCase();
        lang = Langs[lang] ? lang : 'es';


        return {
            locale: lang,
            messages: Langs[lang].msg,
        }
    }

    function changeLanguage(lang) {
        setLanguage(getLanguage(lang));
    }

    return (
        <LanguageContext.Provider value={{i18nConfig, changeLanguage}}>
            <IntlProvider key={i18nConfig.locale}
                          locale={i18nConfig.locale}
                          messages={i18nConfig.messages}>
                {children}
            </IntlProvider>
        </LanguageContext.Provider>
    )

}

export default LanguageProvider;
